import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import NotFound from "./pages/NotFound";
import BlogDetails from "./pages/BlogDetails";
import BlogGrid from "./pages/BlogGrid";
import Neurocentro from "./pages/Neurocentro";
import Careers from "./pages/Careers";
import Consultas from "./pages/Consultas";
import Servicios from "./pages/Servicios";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="blog" element={<BlogGrid />} />
          <Route path="blog-details" element={<BlogDetails />} />
          <Route path="careers" element={<Careers />} />
          <Route path="neurocentro" element={<Neurocentro />} />
          <Route path="consultas" element={<Consultas />} />
          <Route path="servicios" element={<Servicios />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
